module.exports = __webpack_public_path__ + "static/media/multigamecard.2dade5a9.png";